import template from './addedToCartModal.html';
import './addedToCartModal.scss';

class AddedToCartModalController {
    /* @ngInject */
    constructor($window, constants ) {
        this.$close = this.config.close;
        this.$dismiss = this.config.dismiss;
        this.$window = $window;
        this.constants = constants;
    }

    goToCart() {
        this.$window.location.href = this.constants.cartHref;
    }

    close() {
        this.$close();
    }
}

export default {
    template: template,
    bindings: {
        config: '='
    },
    controller: AddedToCartModalController
};